import { each, random } from 'lodash'
import { mapping } from './bridge.json'
import { faker } from '@faker-js/faker'

const mappedRenderType = (logicalType)  => {
  const type = (
    logicalType in mapping.render_types ?
      mapping.render_types[logicalType] :
      null
  )

  return type || logicalType
}

const normalizedFieldDefinition = (definition, renderDefinition) => {
  const renderType = renderDefinition.type
  const renderParameters = renderDefinition.params
    
  let normalized: any = {
    name: definition.id,
    label: definition.label,
    type: mappedRenderType(renderType),
  }


  normalized.render_type = mappedRenderType(renderType)
  normalized.render_params = renderParameters

  if (renderType in mapping.default_render_params) {
    normalized = {
      ...normalized,
      ...mapping.default_render_params[renderType]
    }
  }

  return normalized
}

const orderedFields = (order, groups, fields, render) => {

  const groupKeys = groups.map((group) => group.id)
  const fieldKeys = fields.map((field) => field.id)

  let extractedFields: Array<any> = []

  order.forEach((elementKey) => {

    const isGroup = groupKeys.includes(elementKey)
    const isField = fieldKeys.includes(elementKey)

    if (isField) {
      const field = fields.find((field) => field.id == elementKey)
      const fieldRender = render.find((render) => render.id == field.id)
      extractedFields.push(normalizedFieldDefinition(field, fieldRender))
    } else if (isGroup) {
      const group = groups.find((group) => group.id == elementKey)

      const groupFields = orderedFields(group.fields, groups, fields, render)

      const children: Array<any> = []

      groupFields.forEach(field => {
        if (field.type !== 'file') {
          children.push({
            ...field,
            off: true
          })
        } else {
          let params = []
          if ('render_params' in field && 'value' in field.render_params) {
            params = field.render_params.value
          }
          children.push(field,
            ...params.map((param:any) => ({
              children: `<a id="a${param.n}" href="#attachments">[${param.n}]</a> ${param.name}`,
              component: 'span'
            }))
          )
        }
      })
      
      extractedFields.push({
        type: "group",
        name: group.id,
        children: [
          {
            component: 'h4',
            children: group.title
          },
          ...children
        ]
      })
    }
  })

  return extractedFields
}

export function compileFields(definition: any) : Array<any> {
  
  const renders = definition.head.render
  const order = definition.head.order
  const fields = definition.form.fields
  const groups = definition.head.groups


  const compiledFields = orderedFields(order, groups, fields, renders)

  return compiledFields
}

export function generateFakeData(definition: any) : any {
  const fields = definition.form.fields
  const data = {}
  each(fields, (field) => {
    if (field.type == 'boolean') {
      data[field.id] = Math.random() < 0.5 ? 'yes' : 'no'
    } else if (field.type == 'text') {
      data[field.id] = faker.hacker.phrase()
    } else if (field.type == 'company_name') {
      data[field.id] = faker.random.words(2)
    } else if (field.type == 'name') {
      data[field.id] = faker.name.findName()
    } else if (field.type == 'email') {
      data[field.id] = faker.internet.email()
    } else if (field.type == 'cnpj') {
      data[field.id] = faker.random.numeric(14)
    } else if (field.type == 'address') {
      data[field.id] = faker.address.streetAddress(true)
    } else if (field.type == 'phone') {
      data[field.id] = faker.phone.number()
    }
  })
  return data
}